import { frame } from 'motion'

// Setup
let start = Date.now()
let current = start
let elapsed = 0
// This is 16 - 60fps - 16ms to tick (there is a bug when this is set to 0 by default)
let delta = 16

export default function useTime() {
  if (import.meta.client) {
    frame.render(() => tick(), true)
  }

  const { update } = useUpdate()

  function tick() {
    const currentTime = Date.now()
    delta = currentTime - current
    current = currentTime
    elapsed = current - start

    update()
  }
}
